import { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!email) {
      setErrorMessage("Email id Required");
      return;
    }

    try {
      const auth = getAuth();
      await sendPasswordResetEmail(auth, email);
      setSuccessMessage("Password reset email sent. Please check your inbox.");
      setErrorMessage("");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        setErrorMessage("Email id not registered!");
      }
      setSuccessMessage("");
    }
  };

  return (
    <div className="z-20 md:w-2/6 py-10 px-10 md:mx-10 my-36 bg-opacity-95 rounded-md border bg-white">
      <FontAwesomeIcon
        className="mb-5 text-gray-500 cursor-pointer"
        onClick={onClose}
        icon={faArrowLeft}
      />
      <h1 className="font-semibold text-2xl text-ambhosOrange mb-2">
        Reset Password
      </h1>
      <small className="text-gray-400 font-light">
        Enter your email and we'll send a link to your email to reset your
        password.
      </small>
      <form className="mt-10 flex flex-col" onSubmit={handlePasswordReset}>
        {successMessage ? (
          <p className="border rounded-md p-3 mb-2">{successMessage}</p>
        ) : (
          <div>
            {errorMessage && (
              <p className="text-red-500 mb-2">{errorMessage}</p>
            )}
            <div className="mb-4">
              <input
                type="email"
                value={email}
                placeholder="Enter your email"
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full border-2 border-gray-500 rounded-md py-2 px-2 outline-none`}
              />
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="bg-ambhosOrange text-white px-4 py-2 rounded"
              >
                Reset Password
              </button>
            </div>
          </div>
        )}
      </form>
    </div>
  );
};

export default ForgotPasswordModal;
